import { render, staticRenderFns } from "./ShopPrices.vue?vue&type=template&id=6bd7af4d"
import script from "./ShopPrices.vue?vue&type=script&lang=js"
export * from "./ShopPrices.vue?vue&type=script&lang=js"
import style0 from "./ShopPrices.vue?vue&type=style&index=0&id=6bd7af4d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports